<template>
  <div class="home">
    <!-- 欢迎区域 -->
    <div class="welcome-section">
      <div class="welcome-info">
        <h1 class="welcome-title">{{ greeting }}，{{ username }}</h1>
        <p class="welcome-desc">{{ currentDateTime }}</p>
      </div>
    </div>

    <!-- 统计卡片区域 -->
    <el-row :gutter="20" class="stats-section">
      <el-col :xs="24" :sm="12" :md="6" :lg="6">
        <el-card class="stat-card stat-card-goods" shadow="hover" @click.native="goToRoute('/course')">
          <div class="stat-content">
            <div class="stat-icon goods-icon">
              <i class="el-icon-goods"></i>
            </div>
            <div class="stat-info">
              <div class="stat-value">{{ stats.goodsTotal }}</div>
              <div class="stat-label">商品总数</div>
              <div class="stat-desc">
                <span class="stat-desc-text">今日新增: {{ stats.goodsToday }}</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      
      <el-col :xs="24" :sm="12" :md="6" :lg="6">
        <el-card class="stat-card stat-card-article" shadow="hover" @click.native="goToRoute('/article')">
          <div class="stat-content">
            <div class="stat-icon article-icon">
              <i class="el-icon-document"></i>
            </div>
            <div class="stat-info">
              <div class="stat-value">{{ stats.articleTotal }}</div>
              <div class="stat-label">文章总数</div>
              <div class="stat-desc">
                <span class="stat-desc-text">今日新增: {{ stats.articleToday }}</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :xs="24" :sm="12" :md="6" :lg="6">
        <el-card class="stat-card stat-card-order" shadow="hover" @click.native="goToRoute('/order')">
          <div class="stat-content">
            <div class="stat-icon order-icon">
              <i class="el-icon-s-order"></i>
            </div>
            <div class="stat-info">
              <div class="stat-value">{{ stats.orderTotal }}</div>
              <div class="stat-label">订单总数</div>
              <div class="stat-desc">
                <span class="stat-desc-text">今日新增: {{ stats.orderToday }}</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :xs="24" :sm="12" :md="6" :lg="6">
        <el-card class="stat-card stat-card-online" shadow="hover">
          <div class="stat-content">
            <div class="stat-icon online-icon">
              <i class="el-icon-data-line"></i>
            </div>
            <div class="stat-info">
              <div class="stat-value">{{ stats.onlineGoods }}</div>
              <div class="stat-label">已上架商品</div>
              <div class="stat-desc">
                <span class="stat-desc-text">上架文章: {{ stats.onlineArticle }}</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 数据可视化区域 -->
    <el-row :gutter="20" class="charts-section">
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <el-card class="chart-card" shadow="hover">
          <div slot="header" class="card-header">
            <span class="card-title">商品状态分布</span>
          </div>
          <div ref="goodsChart" class="chart-container"></div>
        </el-card>
      </el-col>
      
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <el-card class="chart-card" shadow="hover">
          <div slot="header" class="card-header">
            <span class="card-title">文章状态分布</span>
          </div>
          <div ref="articleChart" class="chart-container"></div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 快捷操作和最近动态区域 -->
    <el-row :gutter="20" class="content-section">
      <!-- 快捷操作 -->
      <el-col :xs="24" :sm="24" :md="12" :lg="8">
        <el-card class="content-card" shadow="hover">
          <div slot="header" class="card-header">
            <span class="card-title">快捷操作</span>
          </div>
          <div class="quick-access">
            <div
              class="quick-item"
              @click="goToRoute('/course')"
            >
              <div class="quick-icon course-icon">
                <i class="el-icon-goods"></i>
              </div>
              <div class="quick-content">
                <div class="quick-title">网课商品管理</div>
                <div class="quick-desc">管理课程商品信息</div>
              </div>
              <i class="el-icon-arrow-right quick-arrow"></i>
            </div>
            
            <div
              class="quick-item"
              @click="goToRoute('/article')"
            >
              <div class="quick-icon article-icon">
                <i class="el-icon-document"></i>
              </div>
              <div class="quick-content">
                <div class="quick-title">文章管理</div>
                <div class="quick-desc">管理文章内容</div>
              </div>
              <i class="el-icon-arrow-right quick-arrow"></i>
            </div>
            
            <div
              class="quick-item"
              @click="goToRoute('/order')"
            >
              <div class="quick-icon order-icon">
                <i class="el-icon-s-order"></i>
              </div>
              <div class="quick-content">
                <div class="quick-title">订单管理</div>
                <div class="quick-desc">查看和管理订单</div>
              </div>
              <i class="el-icon-arrow-right quick-arrow"></i>
            </div>
          </div>
        </el-card>
      </el-col>

      <!-- 最近商品 -->
      <el-col :xs="24" :sm="24" :md="12" :lg="8">
        <el-card class="content-card" shadow="hover">
          <div slot="header" class="card-header">
            <span class="card-title">最近商品</span>
            <el-button type="text" size="small" @click="goToRoute('/course')">查看更多</el-button>
          </div>
          <div v-loading="goodsLoading" class="recent-list">
            <template v-if="recentGoods.length > 0">
              <div
                v-for="item in recentGoods"
                :key="item.id"
                class="recent-item"
                @click="handleEditGoods(item)"
              >
                <div class="recent-image">
                  <img
                    v-if="item.coverImage"
                    :src="item.coverImage"
                    alt="商品封面"
                    @error="handleImageError"
                  />
                  <div v-else class="no-image-small">无图</div>
                </div>
                <div class="recent-content">
                  <div class="recent-title">{{ item.title || '-' }}</div>
                  <div class="recent-meta">
                    <el-tag :type="getStatusType(item.status)" size="mini">
                      {{ getGoodsStatusText(item.status) }}
                    </el-tag>
                    <span class="recent-time">{{ formatRelativeTime(item.createTime) }}</span>
                  </div>
                </div>
              </div>
            </template>
            <div v-else class="empty-list">暂无数据</div>
          </div>
        </el-card>
      </el-col>

      <!-- 最近文章 -->
      <el-col :xs="24" :sm="24" :md="12" :lg="8">
        <el-card class="content-card" shadow="hover">
          <div slot="header" class="card-header">
            <span class="card-title">最近文章</span>
            <el-button type="text" size="small" @click="goToRoute('/article')">查看更多</el-button>
          </div>
          <div v-loading="articleLoading" class="recent-list">
            <template v-if="recentArticles.length > 0">
              <div
                v-for="item in recentArticles"
                :key="item.id"
                class="recent-item"
                @click="handleEditArticle(item)"
              >
                <div class="recent-image">
                  <img
                    v-if="item.images && item.images.length > 0"
                    :src="item.images[0]"
                    alt="文章图片"
                    @error="handleImageError"
                  />
                  <div v-else class="no-image-small">无图</div>
                </div>
                <div class="recent-content">
                  <div class="recent-title">{{ item.title || '-' }}</div>
                  <div class="recent-meta">
                    <el-tag :type="getValidationType(item.validation)" size="mini">
                      {{ getArticleStatusText(item.validation) }}
                    </el-tag>
                    <span class="recent-time">{{ formatRelativeTime(item.createTime) }}</span>
                  </div>
                </div>
              </div>
            </template>
            <div v-else class="empty-list">暂无数据</div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getGoodsList } from '@/api/goods'
import { getArticleList } from '@/api/article'
import { getOrderStatistics } from '@/api/order'
import { getUsername, getNickName } from '@/utils/auth'
import { formatRelativeTime, getDefaultImagePlaceholder } from '@/utils/index'
import { GOODS_STATUS_TEXT, GOODS_STATUS_TYPE, ARTICLE_VALIDATION_TEXT, ARTICLE_VALIDATION_TYPE } from '@/utils/constants'
import { handleApiError } from '@/utils/errorHandler'
import * as echarts from 'echarts'

export default {
  name: 'Home',
  data() {
    return {
      username: '',
      currentDateTime: '',
      dateTimeTimer: null,
      stats: {
        goodsTotal: 0,
        goodsToday: 0,
        articleTotal: 0,
        articleToday: 0,
        orderTotal: 0,
        orderToday: 0,
        onlineGoods: 0,
        onlineArticle: 0
      },
      recentGoods: [],
      recentArticles: [],
      goodsLoading: false,
      articleLoading: false,
      goodsChart: null,
      articleChart: null
    }
  },
  computed: {
    greeting() {
      const hour = new Date().getHours()
      if (hour < 6) return '凌晨好'
      if (hour < 9) return '早上好'
      if (hour < 12) return '上午好'
      if (hour < 14) return '中午好'
      if (hour < 18) return '下午好'
      if (hour < 22) return '晚上好'
      return '夜深了'
    }
  },
  mounted() {
    this.initUserInfo()
    this.updateDateTime()
    this.dateTimeTimer = setInterval(() => {
      this.updateDateTime()
    }, 1000)
    
    this.loadStats()
    this.loadRecentData()
    
    this.$nextTick(() => {
      this.initCharts()
    })
  },
  beforeDestroy() {
    if (this.dateTimeTimer) {
      clearInterval(this.dateTimeTimer)
    }
    if (this.goodsChart) {
      this.goodsChart.dispose()
    }
    if (this.articleChart) {
      this.articleChart.dispose()
    }
  },
  methods: {
    // 初始化用户信息
    initUserInfo() {
      const nickName = getNickName()
      const userName = getUsername()
      this.username = nickName || userName || '管理员'
    },
    
    // 更新日期时间
    updateDateTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      const weekDays = ['日', '一', '二', '三', '四', '五', '六']
      const weekDay = weekDays[now.getDay()]
      
      this.currentDateTime = `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds} 星期${weekDay}`
    },
    
    // 加载统计数据
    async loadStats() {
      try {
        // 获取商品统计
        const goodsParams = {
          current: 1,
          size: 1,
          goodsType: 1
        }
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        const todayStart = today.toISOString().replace('T', ' ').substring(0, 19)
        const todayEnd = new Date(today.getTime() + 24 * 60 * 60 * 1000 - 1).toISOString().replace('T', ' ').substring(0, 19)
        
        const goodsResponse = await getGoodsList(goodsParams)
        if (goodsResponse.data && goodsResponse.data.success) {
          const goodsData = goodsResponse.data.data
          this.stats.goodsTotal = goodsData.total || 0
          
          // 获取今日新增商品
          const goodsTodayParams = {
            current: 1,
            size: 1,
            goodsType: 1,
            startTime: todayStart,
            endTime: todayEnd
          }
          const goodsTodayResponse = await getGoodsList(goodsTodayParams)
          if (goodsTodayResponse.data && goodsTodayResponse.data.success) {
            this.stats.goodsToday = goodsTodayResponse.data.data.total || 0
          }
          
          // 获取上架商品数
          const goodsOnlineParams = {
            current: 1,
            size: 1,
            goodsType: 1,
            status: 1
          }
          const goodsOnlineResponse = await getGoodsList(goodsOnlineParams)
          if (goodsOnlineResponse.data && goodsOnlineResponse.data.success) {
            this.stats.onlineGoods = goodsOnlineResponse.data.data.total || 0
          }
        }
        
        // 获取文章统计
        const articleParams = {
          current: 1,
          size: 1
        }
        const articleResponse = await getArticleList(articleParams)
        if (articleResponse.data && articleResponse.data.success) {
          const articleData = articleResponse.data.data
          this.stats.articleTotal = articleData.total || 0
          
          // 获取今日新增文章
          const articleTodayParams = {
            current: 1,
            size: 1,
            startTime: todayStart,
            endTime: todayEnd
          }
          const articleTodayResponse = await getArticleList(articleTodayParams)
          if (articleTodayResponse.data && articleTodayResponse.data.success) {
            this.stats.articleToday = articleTodayResponse.data.data.total || 0
          }
          
          // 获取上架文章数
          const articleOnlineParams = {
            current: 1,
            size: 1,
            validation: 1
          }
          const articleOnlineResponse = await getArticleList(articleOnlineParams)
          if (articleOnlineResponse.data && articleOnlineResponse.data.success) {
            this.stats.onlineArticle = articleOnlineResponse.data.data.total || 0
          }
        }

        // 获取订单统计
        const orderStatsResponse = await getOrderStatistics()
        if (orderStatsResponse.data && orderStatsResponse.data.success) {
          const orderData = orderStatsResponse.data.data
          this.stats.orderTotal = orderData.totalOrderCount || 0
          this.stats.orderToday = orderData.todayNewOrderCount || 0
        }

        // 更新图表
        this.$nextTick(() => {
          this.updateCharts()
        })
      } catch (error) {
        handleApiError(error, '加载统计数据失败', { showMessage: false })
      }
    },
    
    // 加载最近数据
    async loadRecentData() {
      // 加载最近商品
      this.goodsLoading = true
      try {
        const goodsParams = {
          current: 1,
          size: 5,
          goodsType: 1
        }
        const response = await getGoodsList(goodsParams)
        if (response.data && response.data.success) {
          this.recentGoods = response.data.data.records || []
        }
      } catch (error) {
        handleApiError(error, '加载最近商品失败', { showMessage: false })
      } finally {
        this.goodsLoading = false
      }
      
      // 加载最近文章
      this.articleLoading = true
      try {
        const articleParams = {
          current: 1,
          size: 5
        }
        const response = await getArticleList(articleParams)
        if (response.data && response.data.success) {
          this.recentArticles = response.data.data.records || []
        }
      } catch (error) {
        handleApiError(error, '加载最近文章失败', { showMessage: false })
      } finally {
        this.articleLoading = false
      }
    },
    
    // 初始化图表
    initCharts() {
      // 商品状态分布图表
      if (this.$refs.goodsChart) {
        this.goodsChart = echarts.init(this.$refs.goodsChart)
        window.addEventListener('resize', () => {
          if (this.goodsChart) {
            this.goodsChart.resize()
          }
        })
      }
      
      // 文章状态分布图表
      if (this.$refs.articleChart) {
        this.articleChart = echarts.init(this.$refs.articleChart)
        window.addEventListener('resize', () => {
          if (this.articleChart) {
            this.articleChart.resize()
          }
        })
      }
      
      this.updateCharts()
    },
    
    // 更新图表数据
    async updateCharts() {
      // 获取商品状态分布数据
      try {
        const statusList = [0, 1, 2] // 草稿、上架、下架
        const goodsStatusData = []
        for (const status of statusList) {
          const params = {
            current: 1,
            size: 1,
            goodsType: 1,
            status: status
          }
          const response = await getGoodsList(params)
          if (response.data && response.data.success) {
            const count = response.data.data.total || 0
            const statusNames = ['草稿', '上架', '下架']
            goodsStatusData.push({
              name: statusNames[status],
              value: count
            })
          }
        }
        
        if (this.goodsChart && goodsStatusData.length > 0) {
          this.goodsChart.setOption({
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b}: {c} ({d}%)'
            },
            legend: {
              orient: 'vertical',
              left: 'left',
              top: 'middle'
            },
            series: [
              {
                name: '商品状态',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                itemStyle: {
                  borderRadius: 10,
                  borderColor: '#fff',
                  borderWidth: 2
                },
                label: {
                  show: true,
                  formatter: '{b}: {c}\n({d}%)'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: 14,
                    fontWeight: 'bold'
                  }
                },
                data: goodsStatusData,
                color: ['#909399', '#67c23a', '#e6a23c']
              }
            ]
          })
        }
      } catch (error) {
        handleApiError(error, '更新商品状态图表失败', { showMessage: false })
      }
      
      // 获取文章状态分布数据
      try {
        const validationList = [0, 1] // 下架、上架
        const articleStatusData = []
        for (const validation of validationList) {
          const params = {
            current: 1,
            size: 1,
            validation: validation
          }
          const response = await getArticleList(params)
          if (response.data && response.data.success) {
            const count = response.data.data.total || 0
            const statusNames = ['下架', '上架']
            articleStatusData.push({
              name: statusNames[validation],
              value: count
            })
          }
        }
        
        if (this.articleChart && articleStatusData.length > 0) {
          this.articleChart.setOption({
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b}: {c} ({d}%)'
            },
            legend: {
              orient: 'vertical',
              left: 'left',
              top: 'middle'
            },
            series: [
              {
                name: '文章状态',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                itemStyle: {
                  borderRadius: 10,
                  borderColor: '#fff',
                  borderWidth: 2
                },
                label: {
                  show: true,
                  formatter: '{b}: {c}\n({d}%)'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: 14,
                    fontWeight: 'bold'
                  }
                },
                data: articleStatusData,
                color: ['#909399', '#67c23a']
              }
            ]
          })
        }
      } catch (error) {
        handleApiError(error, '更新文章状态图表失败', { showMessage: false })
      }
    },
    
    // 跳转路由
    goToRoute(path) {
      this.$router.push(path)
    },
    
    // 编辑商品
    handleEditGoods() {
      this.$router.push({ path: '/course' })
    },
    
    // 编辑文章
    handleEditArticle() {
      this.$router.push({ path: '/article' })
    },
    formatRelativeTime,
    
    // 图片加载错误
    handleImageError(e) {
      e.target.src = getDefaultImagePlaceholder()
    },
    
    // 获取商品状态文本
    getGoodsStatusText(status) {
      return GOODS_STATUS_TEXT[status] || '未知'
    },
    
    // 获取商品状态类型
    getStatusType(status) {
      return GOODS_STATUS_TYPE[status] || ''
    },
    
    // 获取文章状态文本
    getArticleStatusText(validation) {
      return ARTICLE_VALIDATION_TEXT[validation] || '未知'
    },
    
    // 获取文章状态类型
    getValidationType(validation) {
      return ARTICLE_VALIDATION_TYPE[validation] || ''
    }
  }
}
</script>

<style scoped>
.home {
  min-height: calc(100vh - 100px);
  padding: 20px;
}

/* 欢迎区域 */
.welcome-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px;
  padding: 30px;
  margin-bottom: 20px;
  color: #fff;
}

.welcome-info {
  text-align: center;
}

.welcome-title {
  font-size: 32px;
  font-weight: 600;
  margin: 0 0 10px 0;
  color: #fff;
}

.welcome-desc {
  font-size: 16px;
  margin: 0;
  opacity: 0.9;
}

/* 统计卡片区域 */
.stats-section {
  margin-bottom: 20px;
}

.stat-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  overflow: hidden;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.stat-card-goods:hover {
  border-left: 4px solid #409eff;
}

.stat-card-article:hover {
  border-left: 4px solid #67c23a;
}

.stat-card-order:hover {
  border-left: 4px solid #e6a23c;
}

.stat-card-online:hover {
  border-left: 4px solid #f56c6c;
}

.stat-content {
  display: flex;
  align-items: center;
  padding: 10px;
}

.stat-icon {
  width: 70px;
  height: 70px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #fff;
  margin-right: 20px;
  flex-shrink: 0;
}

.goods-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.article-icon {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.order-icon {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.online-icon {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}

.stat-info {
  flex: 1;
}

.stat-value {
  font-size: 32px;
  font-weight: 700;
  color: #303133;
  line-height: 1;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 5px;
}

.stat-desc {
  font-size: 12px;
  color: #c0c4cc;
}

.stat-desc-text {
  color: #909399;
}

/* 图表区域 */
.charts-section {
  margin-bottom: 20px;
}

.chart-card {
  height: 100%;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
}

.card-title {
  font-size: 16px;
  color: #303133;
}

.chart-container {
  width: 100%;
  height: 350px;
}

/* 内容区域 */
.content-section {
  margin-bottom: 20px;
}

.content-card {
  height: 100%;
}

/* 快捷操作 */
.quick-access {
  padding: 10px 0;
}

.quick-item {
  display: flex;
  align-items: center;
  padding: 15px;
  margin-bottom: 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;
}

.quick-item:hover {
  background: #f5f7fa;
  border-color: #409eff;
  transform: translateX(5px);
}

.quick-item:last-child {
  margin-bottom: 0;
}

.quick-icon {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #fff;
  margin-right: 15px;
  flex-shrink: 0;
}

.course-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.article-icon {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.order-icon {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.quick-content {
  flex: 1;
}

.quick-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 5px;
}

.quick-desc {
  font-size: 13px;
  color: #909399;
}

.quick-arrow {
  color: #c0c4cc;
  font-size: 18px;
  transition: all 0.3s ease;
}

.quick-item:hover .quick-arrow {
  color: #409eff;
  transform: translateX(3px);
}

/* 最近列表 */
.recent-list {
  padding: 10px 0;
}

.recent-item {
  display: flex;
  align-items: center;
  padding: 12px;
  margin-bottom: 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;
}

.recent-item:hover {
  background: #f5f7fa;
  border-color: #409eff;
}

.recent-item:last-child {
  margin-bottom: 0;
}

.recent-image {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  overflow: hidden;
  margin-right: 12px;
  flex-shrink: 0;
  background: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.recent-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.no-image-small {
  font-size: 12px;
  color: #c0c4cc;
}

.recent-content {
  flex: 1;
  min-width: 0;
}

.recent-title {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-meta {
  display: flex;
  align-items: center;
  gap: 8px;
}

.recent-time {
  font-size: 12px;
  color: #909399;
}

.empty-list {
  text-align: center;
  padding: 40px 0;
  color: #909399;
  font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .welcome-title {
    font-size: 24px;
  }
  
  .welcome-desc {
    font-size: 14px;
  }
  
  .stat-value {
    font-size: 24px;
  }
  
  .stat-icon {
    width: 60px;
    height: 60px;
    font-size: 28px;
  }
  
  .chart-container {
    height: 280px;
  }
}
</style>
